/*
 *
 * TransactionsDownloadAllPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jun-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import TransactionsDownloadAllPopup from './TransactionsDownloadAllPopup'
import * as TransactionsActions from '../../routes/Transactions/modules/TransactionsActions'
import { doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(TransactionsActions, dispatch),
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = (state) => ({
  isDownloadLoading: nullSafe(() => state.loading.localLoading.get_start_download_authorized_transactions || state.loading.localLoading.get_start_download_accounted_transactions || state.loading.localLoading.get_download_authorized_transactions, false),
  startDate: nullSafe(() => state.popup.popupInfo.startDate, ''),
  endDate: nullSafe(() => state.popup.popupInfo.endDate, ''),
  filterType: nullSafe(() => state.popup.popupInfo.filterType, ''),
  pageNumber: nullSafe(() => state.popup.popupInfo.pageNumber, 1),
  pageSize: nullSafe(() => state.popup.popupInfo.pageSize, 10),
  customPeriod: nullSafe(() => state.popup.popupInfo.customPeriod, null),
  transactionType: nullSafe(() => state.popup.popupInfo.transactionType, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(TransactionsDownloadAllPopup)
